import React from "react";
import { CustomerPortalRequestTableQuery } from "../models";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { useGetRequestsQuery } from "../queries";
import { Column } from "react-data-grid";
import { Table } from "../../../components";
import { getTablePageCount } from "../../../helpers/tableHelpers";
import { renderDate } from "../../../helpers/dayjsHeleprs";
import { useNavigate } from "../../../helpers/navigationHelpers";
import { CPRequest } from "../../../api/models/unified";
import { RequestStateText } from "../../../helpers/requestHelper";

interface Props {
  queryParams: CustomerPortalRequestTableQuery;
  setQueryParams: (queryParams: CustomerPortalRequestTableQuery) => void;
}

const RequestsTable: React.FC<Props> = (props): React.ReactElement => {
  const { queryParams, setQueryParams } = props;
  const { tRequest } = useCustomTranslation();
  const navigate = useNavigate();

  const query = useGetRequestsQuery(queryParams);

  const columns: Column<CPRequest>[] = [
    {
      key: "title",
      name: tRequest("name"),
      sortable: true,
    },
    {
      key: "type",
      name: tRequest("type"),
      renderCell: ({ row }) => tRequest(`type_${row.type}`),
    },
    {
      key: "state",
      name: tRequest("state"),
      cellClass: (row) => RequestStateText[row.state],
      renderCell: ({ row }) => tRequest(`state_${row.state}`),
    },
    {
      key: "created",
      name: tRequest("created"),
      renderCell: ({ row }) => renderDate(row.created),
    },
  ];

  return (
    <Table
      columns={columns}
      data={query.data?.data ?? []}
      loading={query.isLoading}
      queryParams={queryParams}
      onTableQueryChange={setQueryParams}
      pageCount={getTablePageCount(
        query.data?.total ?? 1,
        queryParams.pageSize,
      )}
      onRowClick={(item) => navigate.goTo(`requests/${item.id}`)}
    />
  );
};

export default RequestsTable;
